import React, { useEffect } from "react";
import { Props } from "./NuevaCompra-type";
import { Protected } from "@/components/layout/Protected";
import { Loading } from "@/components/common/Loading";
import { Box, Button, Divider, Grid, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField, Typography } from "@mui/material";
import Paper from '@mui/material/Paper';
import { useLocalStorage } from '@toolbox/hooks/local-storage.hook';
import {KEY_EDIT_COMPRA, KEY_EMPRESA, PRODUCTS_CARD, KEY_EDIT_COMPRA_ID, KEY_EDIT_COMPRA_PROVEEDOR_ID} from '@constants/local-storage';
 import { productoService } from "@/service/services/Producto.service";
import  "../../Home/Home.sass";
import { PagoCompra } from "../components/PagoCompra";
import { saveLocalStorage } from "@/toolbox/helpers/local-storage-helper";
import { useHistory } from 'react-router-dom';
import { ROUTE_COMPRAS } from "@/toolbox/constants/route-map";
import { Popup } from "@/views/Editor/components/Popup";
import { ModalConfirm } from "../components/ModalConfirm";
import { AddProductoS } from "@/views/Productos/AddProductoS";
import AddBoxIcon from '@mui/icons-material/AddBox';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { ModalDescuentoCompra } from "../components/ModalDescuentoCompra";

//TabPanel
interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
}
function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography variant="h6">{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

export const NuevaCompra: React.FC<Props> = (props:Props):JSX.Element => {

    const [loading, setLoading] = React.useState<boolean>(false);
    const [dataEmpresa] = useLocalStorage(KEY_EMPRESA, {
        id: 0, id_tipo_empresa:0, equivalencia_puntos: 0,
        id_country: 0, country_name: "", country_abbreviation: "",
     });

     // eslint-disable-next-line
    const [value, setValue] = React.useState(0);
    const [textSearch, setTextSearch] = React.useState<string>("");

    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);

    const [products, setProducts] = React.useState<Array<any>>([]);
    const [filter, setFilter] = React.useState<Array<any>>([]);

    const [cardState, setCardState] = React.useState([]);

    const [editCompra] = useLocalStorage(KEY_EDIT_COMPRA, []);
    const [card_shop] = useLocalStorage(PRODUCTS_CARD, []);

    const [openPopup, setOpenPopup] = React.useState(false);
    const [popUp, setPopUp] = React.useState<String>('');
    const [showModalConfirm, setShowModalConfirm]= React.useState(false);
    const [codigoBarras, setCodigoBarras]= React.useState<any>('');
    // eslint-disable-next-line
    const [newProduct, setNewProduct]= React.useState<any>('');

   // eslint-disable-next-line
    const [submodulos, setSubModulos] = React.useState([]);
    // eslint-disable-next-line
    const [showBarras, setShowBarras] = React.useState<boolean>(false);

    const [editMode, setEditMode] = React.useState<boolean>(false);
    const [tipoDescuento, setTipoDescuento] = React.useState<any>(1);
    const [valorDescuento, setValorDescuento] = React.useState<any>(0);
    const [indexCart, setIndexCart] = React.useState<any>(0);

    const history = useHistory();

    useEffect(() => {
        getProducts();
        // listAllSubmodulos();
        setCardState(card_shop)
    }, // eslint-disable-next-line
    [])

    useEffect(() => {
      if (showBarras){
         let inputT = document.getElementById("mi-codigo-de-barras");
         inputT && inputT.focus();
      }
    }, // eslint-disable-next-line
    [showBarras])

    useEffect(() => {
      if (textSearch) {
         let copyFilters = []
         copyFilters = products.filter(producto => (producto?.nombre.toLowerCase().includes(textSearch.toLowerCase()) || producto?.codigo_erp.toLowerCase().includes(textSearch.toLowerCase())) )
         setFilter([...copyFilters])
      }
   }, // eslint-disable-next-line
   [textSearch])

    const getProducts = async() => {
        setLoading(true);
        await productoService.getProductosInsumo(dataEmpresa.id).then((data) => {
            if(data.status === 200){
                setProducts(data.productos);
                setFilter(data.productos)
            }
            setLoading(false);
        })
    }

    const openModalConfirm=()=>{
        setShowModalConfirm(true);
    }

    const closeModalConfirm=()=>{
        setShowModalConfirm(false);
    }

    const handleKeyDown = async (event) => {
      let codigo: any = document.getElementById("mi-codigo-de-barras");
      if(event.keyCode === 13){
        let newValue = codigo.value;

        setLoading(true);
        await productoService.getProductsByCodigo(newValue).then((data) =>{
            if(data.status === 200){
                codigo.value = ""
                setTextSearch(newValue);
                // eslint-disable-next-line
                (data.productos).map((producto) =>{
                    handleSelectProduct(producto);
                })
            }else{
                openModalConfirm();
                setPopUp('modalConfirm');
                setCodigoBarras(newValue);
            }
            setLoading(false);
        })
     }else{
        let texto = `${event.target.value}`;
        setTextSearch(texto);
        if (!texto) {
            setFilter([...products])
        }
     }
    }

    const handleChangeRowsPerPage = (event)   =>{
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
     const handleChangePage = (event, newPage)  => {
        setPage(newPage);
    };

    const handleSelectProduct = (product) => {
        let card: Array<any> =  cardState;
        let exits: boolean = false;
        for (let i = 0; i < card.length; i++) {
            if(card[i].codigo_erp === product?.codigo_erp && card[i].nombre === product?.nombre){
            exits = true
            }
            if(Object.keys(editCompra).length > 0){
                if(card[i].codigo === product?.codigo && card[i].nombre === product?.nombre)
                {exits = true}
            }
        }
        if (!exits) {

            card.push({
               ...product,
            })
        }
        setCardState([...card])
        saveLocalStorage(PRODUCTS_CARD, card);
    }

    const handleDeleteProduct = (index: number) => {
        let card: Array<any> = cardState;
        card.splice(index, 1);
        setCardState([...card])
    }

    const getProductCantidad = (e, index: number) => {
        let card: Array<any> = cardState;
        card[index].cantidad = e.target.value;
        setCardState([...card])
    }

    const getProductPrecio = (e, index: number) => {

        let card: Array<any> = cardState;
        card[index].precio_unidad = e.target.value;
        setCardState([...card])
    }

    const saveDescuento = (type, value, index) => {
        let card: Array<any> = cardState;
        card[index].tipoDescuento = type;
        card[index].valorDescuento = value;
        setCardState([...card])
    }

    const salirEdicion = ()=>{
        localStorage.removeItem(KEY_EDIT_COMPRA);
        localStorage.removeItem(PRODUCTS_CARD);
        localStorage.removeItem(KEY_EDIT_COMPRA_ID);
        localStorage.removeItem(KEY_EDIT_COMPRA_PROVEEDOR_ID);
        history.push(ROUTE_COMPRAS);
    }

    return (
        <Protected>
            {loading && <Loading/>}
            <Grid container>
            <Grid item sm={6}  sx={{minHeight:'60vh', maxHeight:'80vh', overflowY:'scroll'}}>
            <Box sx={{ maxWidth: '100%', bgcolor: 'background.paper'}}>

            <Box sx={{backgroundColor: '#EDEDED'}}>
            <TabPanel value={value} index={0} key={0} >
            <div className="H-card__fcontainer">
                <div className="">
                    <div className="subModulo_container">
                        <span style={{marginRight:"15px"}} >Agregar Producto:</span>
                        <AddBoxIcon className="iconAddProduct" fontSize="large"
                            onClick={() => {
                                setOpenPopup(true);
                                setPopUp('addNewProduct');
                                setEditMode(true);
                                setNewProduct('addNewProduct');
                            }}
                        />
                    </div>

                    <Divider style={{marginTop:'20px', marginBottom:'20px'}} />

                    <div className="subModulo_container">
                        <span>Filtro:</span>
                        {/* {
                           !showBarras &&
                           <TextField
                              type="text"
                              value={textSearch}
                              placeholder="Buscar por código o nombre del producto"
                              onChange={handleChangeSearch}
                              classes={{
                                 root: "H-card__fcontainer__filter__input"
                              }}
                              style={{backgroundColor: "white", width:"290px", marginLeft: "10px"}}
                           />
                        } */}
                        <TextField
                            type="text"
                            id="mi-codigo-de-barras"
                            placeholder="Buscar..."
                            onKeyDown={handleKeyDown}
                            className="H-card__fcontainer__filter__input"
                            style={{backgroundColor: "white", width:"290px", marginLeft: "10px"}}
                        />
                        {
                            Object.keys(editCompra).length > 0 && (
                                <Box sx={{display:'flex',width:'100%',flexDirection: 'row-reverse', marginLeft: '20px', marginRight:'-10px'}}>
                                    <Button variant={'outlined'} onClick={()=>{
                                        salirEdicion()
                                    }}>
                                        Salir de modo edicion
                                    </Button>
                                </Box>
                            )
                        }
                     {/* <Box sx={{display:'flex', justifyContent: "flex-end", width:'100%', }}>
                        <Button variant={'outlined'} onClick={()=>{ setShowBarras(!showBarras) }} sx={{textTransform: "capitalize"}}>
                           {showBarras ? "Ocultar modo código barras" : "Código barras"}
                        </Button>
                     </Box> */}
                    </div>

                </div>
                <span className="H-card__fcontainer__infoTable" style={{width: "100%", display:"inline-flex"}}>*Para agregar un producto al carrito, de "click" sobre el nombre.</span>
                <span className="H-card__fcontainer__infoTable" style={{width: "100%"}}>*Moneda: {dataEmpresa.country_abbreviation}</span>
            </div>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">

                    <TableHead>
                       <TableRow>
                       <TableCell>Código</TableCell>
                       <TableCell>Nombre</TableCell>
                       <TableCell>Stock Actual</TableCell>
                       <TableCell>Stock Requerido</TableCell>
                       </TableRow>
                    </TableHead>

                    <TableBody>
                        {
                           //(rowsPerPage > 0
                              /* ? filter.slice(page * rowsPerPage, page *rowsPerPage +rowsPerPage)
                              : filter) */
                              filter.map((product, index) => (
                                 <TableRow
                                     key={product.id}
                                     sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                     classes={{
                                         hover: 'hover-row-t'
                                     }}
                                 >
                                     <TableCell component="th" scope="row">
                                     <span className="tabla">{product.codigo_erp}</span>
                                     </TableCell>
                                     <TableCell component="th" scope="row">
                                         <button className="H-card__tableButton" onClick={()=>handleSelectProduct(product)}>
                                            {
                                                product.stock == 0 && (
                                                    <span className="tabla" style={{color:'red'}}>
                                                        {product.nombre.charAt(0).toUpperCase() + product.nombre.slice(1).toLowerCase()}
                                                    </span>
                                                )
                                            }
                                            {
                                                product.stock < product.stock_minimo && (
                                                    <span className="tabla" style={{color:'red'}}>
                                                        {product.nombre.charAt(0).toUpperCase() + product.nombre.slice(1).toLowerCase()}
                                                    </span>
                                                )
                                            }
                                            {
                                                (product.stock > product.stock_minimo) && ((product.stock - product.stock_minimo) <= 5) && (
                                                    <span className="tabla"  style={{color:'orange'}}>
                                                        {product.nombre.charAt(0).toUpperCase() + product.nombre.slice(1).toLowerCase()}
                                                    </span>
                                                )
                                            }
                                            {
                                                (product.stock > product.stock_minimo)&& ((product.stock - product.stock_minimo) >= 6) && (
                                                    <span className="tabla">
                                                        {product.nombre.charAt(0).toUpperCase() + product.nombre.slice(1).toLowerCase()}
                                                    </span>
                                                )
                                            }
                                         </button>
                                     </TableCell>
                                     <TableCell component="th" scope="row">
                                       <span className="tabla">{product.stock}</span>
                                     </TableCell><TableCell component="th" scope="row">
                                       <span className="tabla">{product.stock_minimo}</span>
                                     </TableCell>
                                 </TableRow>
                             )
                             )

                        }

                    </TableBody>
                    <TableFooter>
                    <TableRow>
                        <TablePagination
                            count= {filter.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                            rowsPerPageOptions={[10, 15, 20]}
                            labelRowsPerPage={<span className="tabla">Filas:</span>}
                            labelDisplayedRows={({ page }) => {
                            return `Página: ${page+1}`;
                            }}
                            SelectProps={{
                                inputProps: {
                                "aria-label": "page number"
                                }
                            }}
                            showFirstButton={true}
                            showLastButton={true}
                        />
                    </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
            </TabPanel>
            </Box>
            </Box>
            </Grid>

            <Grid item sm={6} container direction='row'>
            <Grid xs={12} sx={{minHeight:'45vh', maxHeight:'45vh', overflowY:'scroll', padding: '10px'}}>
                    <div className="H-card__title" style={{paddingLeft: '10px', paddingTop:'10px'}}>
                        {`Productos Seleccionados | Moneda: ${dataEmpresa.country_abbreviation}`}
                    </div>
                    <div className="H-card__separator"></div>
                    <div className="H-card__list">
                        {
                            cardState.map((product, index) => (
                                <div className="H-card__list__item">
                                    <div className="content-info">
                                        <div className="info">
                                            <span className="name">
                                                {product.nombre.charAt(0).toUpperCase() + product.nombre.slice(1).toLowerCase()}
                                            </span>
                                        </div>
                                        <span>Min. {(product?.stock_minimo - product?.stock) <= 0 ? "1": product?.stock_minimo - product?.stock} u.</span>
                                        <span className="price">
                                            cant.
                                            <input
                                                style={{width: "50px"}}
                                                type="number" name="cantidad"
                                                placeholder="cantidad"
                                                value={product.cantidad}
                                                onChange={(e)=>getProductCantidad(e,index)} />
                                            <span> a </span>
                                            <input
                                                style={{width: "100px", marginRight: "3px"}}
                                                type="number"
                                                name="precio_unidad"
                                                placeholder="precio/u"
                                                value={product.precio_unidad}
                                                onChange={(e)=>getProductPrecio(e,index)} />
                                            {dataEmpresa.country_abbreviation} c/u
                                        </span>
                                    </div>

                                    <button className="dissmiss-more delete" onClick={()=>handleDeleteProduct(index)}>x</button>
                                    <button style={{color:'green', border:'none', background:'white', cursor:'pointer'}} onClick={() => {
                                        setOpenPopup(true);
                                        setPopUp('showModalDiscount');
                                        setIndexCart(index)
                                        }
                                    }>
                                        <LocalOfferIcon/>
                                    </button>
                                </div>
                            ))
                        }
                    </div>
            </Grid>
            <Grid xs={12} sx={{minHeight:'35vh', maxHeight:'35vh', overflowY:'scroll'}}>
                <PagoCompra
                    productsCard={cardState}
                />
            </Grid>
            </Grid>

            </Grid>
            <Box>
                {
                    popUp === 'addNewProduct' && (
                        <Popup
                        largo="sm"
                        title = 'Agregar Producto'
                        openPopup = {openPopup}
                        setOpenPopup = {setOpenPopup}
                        >
                            <AddProductoS
                                closeModal={() => {setOpenPopup(false)}}
                                getProducts={getProducts}
                                editMode = {editMode}
                            />
                        </Popup>

                    )
                }
            </Box>

            <Box>
                {
                    popUp === 'modalConfirm' && (
                        <ModalConfirm
                            open={showModalConfirm}
                            closeModal={closeModalConfirm}
                            codigoBarras={codigoBarras}
                            getProducts={getProducts}
                            isHome={false}
                        />
                    )
                }
            </Box>
            <Box>
            {
                    popUp === 'showModalDiscount' && (
                        <Popup
                        largo="sm"
                        title = 'Agregar Descuento'
                        openPopup = {openPopup}
                        setOpenPopup = {setOpenPopup}
                        >
                            <ModalDescuentoCompra
                                closeModal={() => {setOpenPopup(false)}}
                                setTipoDescuento={setTipoDescuento}
                                tipoDescuento={tipoDescuento}
                                setValorDescuento={setValorDescuento}
                                valorDescuento={valorDescuento}
                                indexCart={indexCart}
                                saveDescuento={saveDescuento}
                                productsCard={cardState}
                            />
                        </Popup>

                    )
                }
            </Box>
        </Protected>
    );
}
